import { render, staticRenderFns } from "./viewer_sidebar_panels.vue?vue&type=template&id=2259df9b&scoped=true&"
import script from "./viewer_sidebar_panels.vue?vue&type=script&lang=js&"
export * from "./viewer_sidebar_panels.vue?vue&type=script&lang=js&"
import style0 from "./viewer_sidebar_panels.vue?vue&type=style&index=0&id=2259df9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2259df9b",
  null
  
)

export default component.exports